export default [
  {name: 'SI', value: true},
  {name: 'NO', value: false},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/yesno.js